import { AnnotationManager, IViewerState, ToolTipManager } from '../Viewer.models'
import { Tool, ToolType } from './Tool'
import MoveTool from './Move.tool'
import MeasureTool from './Measure.tool'
import MeasureScaleTool from './MeasureScale.tool'
import PolygonTool from './Polygon.tool'
import CircleTool from './Circle.tool'
import SquareTool from './Square.tool'
import ModifyTool from './Modify.tool'
import SelectTool from './Select.tool'
import { TranslateTool } from './Translate.tool'
import RotationTool from '@/modules/viewerModule/viewer/tools/Rotation.tool'

export default class ToolFactory {
    private static instance: ToolFactory;

    // eslint-disable-next-line no-useless-constructor
    private constructor() { }

    private toolCacheMap: Map<ToolType, Tool>=new Map()

    public static getInstance(): ToolFactory {
        if (!ToolFactory.instance) {
            this.reset()
        }

        return ToolFactory.instance
    }

    public static reset(): void {
        this.instance = new ToolFactory()
    }

    public getCachedTool(type: ToolType):Tool | undefined {
        const tool = this.toolCacheMap.get(type)
        return tool
    }

    public getTool(type: ToolType, state: IViewerState, annotationManager: AnnotationManager, tooltipManager:ToolTipManager): Tool | undefined {
        let tool = this.getCachedTool(type)

        if (!tool) {
            switch (type) {
            case ToolType.MOVE:
                tool = new MoveTool(state, annotationManager, tooltipManager)
                break
            case ToolType.MEASURING:
                tool = new MeasureTool(state, annotationManager, tooltipManager)
                break
            case ToolType.MEASURING_SCALE:
                tool = new MeasureScaleTool(state, annotationManager, tooltipManager)
                break
            case ToolType.FREE_POLYGON:
                tool = new PolygonTool(state, annotationManager, tooltipManager)
                break
            case ToolType.CIRCLE:
                tool = new CircleTool(state, annotationManager, tooltipManager)
                break
            case ToolType.SQUARE:
                tool = new SquareTool(state, annotationManager, tooltipManager)
                break
            case ToolType.EDIT:
                tool = new ModifyTool(state, annotationManager, tooltipManager)
                break
            case ToolType.EDIT_DETAILS:
                tool = new SelectTool(state, annotationManager, tooltipManager)
                break
            case ToolType.MOVE_CANVAS:
                tool = new TranslateTool(state, annotationManager, tooltipManager)
                break
            case ToolType.ROTATION:
                tool = new RotationTool(state, annotationManager, tooltipManager)
                break
            }
            if (tool) { this.toolCacheMap.set(type, tool) }
        }
        return tool
    }
}
